import React from "react";
import LoginPage from "./pages/LoginPage";

const App: React.FC = () => {
  // Define what happens on login success
  const handleLoginSuccess = (user: {
    mobileNumber: string;
    token: string;
  }) => {
    console.log("Login successful for:", user.mobileNumber);
    // Here you can redirect the user, store the token, etc.
  };

  // Define what happens on login failure
  const handleLoginFailure = (error: string) => {
    console.error("Login failed:", error);
    // Here you could show an error message to the user
  };

  return (
    <div className="App">
      <LoginPage
        onLoginSuccess={handleLoginSuccess}
        onLoginFailure={handleLoginFailure}
      />
      {/* <DashboardPage /> */}
    </div>
  );
};

export default App;
